/** Map app routes to i18n keys under `nav.*` */
export const ROUTE_I18N_KEYS = {
  "/": "nav.dashboard",
  "/pos": "nav.pointOfSale",
  "/waiter": "nav.waiterOrders",
  "/pos/held-bills": "nav.heldBills",
  "/reports/bill-history": "nav.posBillHistory",
  "/tables": "nav.tableManagement",
  "/reservations": "nav.reservations",
  "/kds": "nav.kitchenOrders",
  "/delivery": "nav.delivery",
  "/online/orders": "nav.onlineOrders",
  "/online/history": "onlineOrders.historyTitle",
  "/admin/online-store": "nav.onlineStore",
  "/masters/main-menu": "nav.mainMenu",
  "/masters/sub-menu": "nav.subMenu",
  "/masters/menu-item": "nav.menuItem",
  "/masters/menu-item/list": "nav.menuItem",
  "/masters/menu-item/new": "nav.menuItemNew",
  "/masters/kitchen-notes": "nav.kitchenNotes",
  "/masters/kot": "nav.kotMaster",
  // "/masters/promotions": "nav.promotions",
  // "/inventory": "nav.inventory",
  "/masters/tables": "nav.tables",
  "/masters/table-designer": "nav.tableDesigner",
  "/masters/customers": "nav.customers",
  "/masters/suppliers": "nav.suppliers",
  "/masters/delivery-areas": "nav.deliveryAreas",
  "/masters/delivery-persons": "nav.deliveryPersons",
  // "/accounts/schedules": "nav.schedules",
  // "/accounts/accounts": "nav.accountsChart",
  // "/accounts/receipt": "nav.receiptVoucher",
  // "/accounts/payment": "nav.paymentVoucher",
  // "/accounts/journal": "nav.journalVoucher",
  // "/accounts/contra": "nav.contraVoucher",
  // "/accounts/debit-note": "nav.debitNote",
  // "/accounts/credit-note": "nav.creditNote",
  // "/accounts/ledger": "nav.ledgerReport",
  // "/accounts/trial-balance": "nav.trialBalance",
  // "/accounts/profit-loss": "nav.profitLoss",
  // "/accounts/balance-sheet": "nav.balanceSheet",
  // "/accounts/cash-book": "nav.cashBook",
  // "/accounts/bank-book": "nav.bankBook",
  // "/accounts/day-book": "nav.dayBook",
  "/reports": "nav.reportCenter",
  "/admin/users": "nav.users",
  "/admin/roles": "nav.roles",
  "/admin/audit-log": "nav.auditLog",
  "/admin/counters": "nav.counters",
  "/admin/printers": "nav.printers",
  "/admin/company": "nav.companySetup",
  "/admin/restaurant": "nav.restaurantSetup",
  "/admin/tax": "nav.taxSettings",
  "/admin/general": "nav.generalSettings",
};

/** Map report routes to i18n keys under `reports.*` */
export const REPORT_I18N_KEYS = {
  "/reports/daily-sales": "reports.dailySales",
  "/reports/bill-history": "nav.posBillHistory",
  "/reports/counter-sales": "reports.counterSales",
  "/reports/item-sales": "reports.itemSales",
  "/reports/tax": "reports.tax",
  "/reports/category-sales": "reports.catSales",
  "/reports/top-items": "reports.topItems",
  "/reports/customer-sales": "reports.customer",
  "/reports/customer-ledger": "reports.customerLedger",
  "/reports/customer-age-wise": "reports.customerAgeWise",
  "/reports/supplier-summary": "reports.supplier",
  "/reports/supplier-ledger": "reports.supplierLedger",
  "/reports/supplier-age-wise": "reports.supplierAgeWise",
  "/reports/delivery-summary": "reports.delivery",
  "/reports/delivery-person-sales": "reports.deliveryPerson",
  "/reports/delivery-area-sales": "reports.deliveryArea",
  "/reports/kitchen": "reports.kitchen",
  "/reports/order-summary": "reports.orderSummary",
  "/reports/cash-collection": "reports.cashCollection",
  "/reports/z-report": "reports.zReport",
  "/reports/x-report": "reports.xReport",
  "/reports/sales-day-book": "reports.salesDayBook",
  "/reports/ledger": "reports.ledger",
  "/reports/trial-balance": "reports.trialBalance",
  "/reports/profit-loss": "reports.profitLoss",
  "/reports/balance-sheet": "reports.balanceSheet",
  "/reports/cash-book": "reports.cashBook",
  "/reports/bank-book": "reports.bankBook",
  "/reports/day-book": "reports.dayBook",
  "/reports/financial-statements": "reports.financialStatements",
  "/reports/condensed-stock": "reports.inventory",
  "/reports/opening-stock": "reports.openingStock",
  "/reports/physical-stock": "reports.physicalStock",
};
